export default function PortfolioItem(props) {
  const { ProjectImags, ProjectTitle, ProjectTechnology, ProjectWebsiteLink } =
    props;

  return (
    <div className="flex flex-col px-5">
      <div className="projectContainer w-80 h-80 relative rounded-3xl overflow-hidden bg-violet-400 flex justify-center items-center">  
        <img className="w-full h-full lg:h-full" src={ProjectImags} alt="Spotify Clone" />
        <div
          className={
            "overlay absolute h-full w-full bg-violet-950 opacity-0 transition-all duration-500 hover:opacity-90 flex justify-center items-center flex-col"
          }
        >
          <p className="text-white font-bold text-3xl">{ProjectTitle}</p>
          <a
            href={ProjectWebsiteLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="rounded-3xl px-5 py-3 mt-5 border-2 border-violet-600 font-bold text-white hover:bg-violet-900  hover:shadow-violet-500 transition-all duration-300">
              Visit
              <span className="ml-2 mb-2 font-extrabold text-base">&gt;</span>
            </button>
          </a>
        </div>
      </div>
      <span className="font-semibold text-lg text-center mt-5">
        {ProjectTechnology}
      </span>
    </div>
  );
}
